var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PlanSelectionCard',{attrs:{"title":_vm.foundationCardTitle,"basic-card":!_vm.isFoundationGold,"features":_vm.foundationCardData,"theme":_vm.theme,"read-only":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }